import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebfde576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_ward_card = _resolveComponent("ward-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_clinic_card = _resolveComponent("clinic-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_nursing_tasks = _resolveComponent("nursing-tasks")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "tonal",
              class: "rounded-shaped",
              color: "blue-grey-lighten-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-home")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Home ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8 text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tooltip, {
              text: "Change Location",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ class: "mr-2" }, props, {
                  color: "primary",
                  "prepend-icon": "mdi-location-exit"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(" Location ")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.store)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "ma-0",
          flat: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
              color: "primary",
              centered: "",
              stacked: "",
              variant: "elevated"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "tab-1",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    (_ctx.store.location !== 'Clinic A')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-bed-empty")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Beds ")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.store.location === 'Clinic A')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-bed-empty")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Clinic ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "tab-2",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-format-list-checks")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Tasks ")
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_window, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "tab-1" }, {
                  default: _withCtx(() => [
                    (_ctx.store.location !== 'Clinic A')
                      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "item"
                                }, [
                                  _createVNode(_component_ward_card, {
                                    title: location.bed,
                                    patient: location.patient
                                  }, null, 8, ["title", "patient"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.store.location === 'Clinic A')
                      ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_clinic_card)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "tab-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      flat: "",
                      class: "ma-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_nursing_tasks)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}